import URL from 'utils/URL';

export const getRedirectUrlConfig = (href: string, isTigerAPP: boolean) => {
    const regResult = href.match(/\/transaction\/plaid\/(\w+)\/?(inapp)?/);
    const source = regResult?.[1],
        inapp = Boolean(regResult?.[2]);

    const nextPath = URL.merge(`/profile/${source === 'withdraw' ? 'withdraw' : 'deposit'}/ach/plaid-continue`, {
        query: URL.current(href).query
    });

    if (inapp && !isTigerAPP) {
        const nextUrl = URL.merge(href, nextPath);

        return {
            source,
            inapp,
            url: URL.merge('https://tradeup.com/activity/forapp/nativeapp?type=nbllq.h&iscallback=1', {
                query: {
                    url: nextUrl,
                    fallback: nextUrl
                }
            })
        };
    }

    return {
        source,
        inapp,
        url: nextPath
    };
};
